import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteAccount } from 'shared/services/backend-api';
import { clearApp } from 'shared/services/backend-api/helpers';

export const useDeleteAccountMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await deleteAccount();
      await clearApp();
      client.clear();
    },
  });
};
